interface ColorPickerProps {
  selectedColor: string;
  onColorChange: (color: string) => void;
}

const PRESET_COLORS = [
  { color: '#00FF00', label: 'Grün' },      // Green
  { color: '#0000FF', label: 'Blau' },      // Blue
  { color: '#FF0000', label: 'Rot' },       // Red
  { color: '#000000', label: 'Schwarz' },   // Black
  { color: '#FFFF00', label: 'Gelb' },      // Yellow
  { color: '#FFC0CB', label: 'Pink' },      // Pink
  { color: '#FFA500', label: 'Orange' },    // Orange
  { color: '#FFFFFF', label: 'Weiß' },      // White
  { color: '#808080', label: 'Grau' },      // Gray
];

export function ColorPicker({ selectedColor, onColorChange }: ColorPickerProps) {
  return (
    <div className="space-y-4">
      <div>
        <label className="block text-sm font-medium mb-2">Ausgewählte Farbe</label>
        <div className="flex gap-3 items-center">
          <div
            className="w-20 h-20 rounded border-2 border-border"
            style={{ backgroundColor: selectedColor }}
          />
          <div className="flex-1">
            <input
              type="text"
              value={selectedColor}
              readOnly
              className="w-full px-3 py-2 border border-input bg-muted rounded font-mono text-sm cursor-not-allowed"
              placeholder="#000000"
            />
          </div>
        </div>
      </div>

      <div>
        <label className="block text-sm font-medium mb-2">Erlaubte Farben</label>
        <div className="grid grid-cols-3 gap-2">
          {PRESET_COLORS.map(({ color, label }) => (
            <button
              key={color}
              onClick={() => onColorChange(color)}
              className={`flex items-center justify-start gap-2 px-3 py-2.5 rounded border-2 transition-all min-w-0 ${
                selectedColor.toUpperCase() === color.toUpperCase()
                  ? 'border-primary ring-2 ring-primary'
                  : 'border-border hover:border-primary/50'
              }`}
              title={`${label} (${color})`}
            >
              <div
                className="w-6 h-6 rounded border border-border flex-shrink-0"
                style={{ backgroundColor: color }}
              />
              <span className="text-xs font-medium truncate">{label}</span>
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}

